import Const from 'constants';
import {GameTotalComponent as LOLGameTotalComponent} from './sports/lol';
import {GameTotalComponent as MLBGameTotalComponent} from './sports/mlb';
import {GameTotalComponent} from './index';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportMlb()) {
            return MLBGameTotalComponent;
        }

        if (sportConfig.isSportLol()) {
            return LOLGameTotalComponent;
        }

        return GameTotalComponent;
    },
};

export {Factory};
